import React from "react";
import { Modal, Typography, Alert, Divider } from "antd";

import "./LocationAccess.css"; // Custom CSS for styling

const { Text } = Typography;

const LoginInfoModal = ({ isVisible, handleCancel }) => {
  return (
    <Modal
      className="location-modal"
      title={<div className="modal-title">Usage of Email and User ID</div>}
      open={isVisible}
      footer={null}
      centered
      width={720}
      onCancel={handleCancel}
    >
      <div className="modal-content">
        <Alert
          description={
            <>
              <Text className="text-loc-modal">
                If you turn this feature on, Then all the accounts created from
                this organization would require both User ID and email to login.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                This optional feature can be used to add additional
                authentication while login.
              </Text>
            </>
          }
          type="info"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default LoginInfoModal;
